module.exports = __webpack_public_path__ + "static/img/home-healthy-life.702e132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home-healthy-life.jpg
// module id = DWA+
// module chunks = 0